import moment from "../../../node_modules/moment/moment";
import { MeritGroupStep } from "./MeritGroupStep";


export class AdminPreviewInscriptionMeritStep extends MeritGroupStep {
    private _type: number;
    private _meritPresentationStartDate: moment.Moment | null;
    private _meritPresentationEndDate: moment.Moment | null;
    private _allowPostInscriptionMeritPresentation: boolean;
    
    constructor(step: any) {
        super(step);
        this._type = step.type;
        this._meritPresentationStartDate = step.meritPresentationStartDate ? moment(step.meritPresentationStartDate) : null;
        this._meritPresentationEndDate = step.meritPresentationEndDate ?  moment(step.meritPresentationEndDate) : null;
        this._allowPostInscriptionMeritPresentation = step.allowPostInscriptionMeritPresentation;
    }
    public get type() {
        return this._type;
    }
    public get meritPresentationStartDate() {
        return this._meritPresentationStartDate;
    }
    public get meritPresentationEndDate() {
        return this._meritPresentationEndDate;
    }
    public get allowPostInscriptionMeritPresentation() {
        return this._allowPostInscriptionMeritPresentation;
    }
}